define( 'ANSI/Utility/SitecoreUtils', [], function () {
    'use strict';

    function sitecoreUtils() {
    }
    sitecoreUtils.prototype = {
        constructor: sitecoreUtils,
        isEditing: function () {
            //Check to see if in Sitecore EE.
            return ( typeof Sitecore != typeof void 0 && typeof Sitecore.PageModes != typeof void 0 && Sitecore.PageModes != null && Sitecore.PageModes.PageEditor != null );
        }
    };

    return sitecoreUtils;
} );
